import { render, staticRenderFns } from "./QuestionSlide.vue?vue&type=template&id=1ff1a16c&scoped=true&"
import script from "./QuestionSlide.vue?vue&type=script&lang=js&"
export * from "./QuestionSlide.vue?vue&type=script&lang=js&"
import style0 from "./QuestionSlide.vue?vue&type=style&index=0&id=1ff1a16c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ff1a16c",
  null
  
)

export default component.exports